// Los widgets guardan su posición/tamaño (x,y,width,height) en una de dos
// unidades, marcadas por `layoutUnit`:
//  - 'px' (legado, default): valores absolutos en pixeles, tal cual se
//    guardaban antes de este cambio. Un dashboard viejo se sigue viendo
//    EXACTAMENTE igual, sin importar el tamaño de pantalla.
//  - 'pct': valores relativos, expresados como % (0-100) del ancho del
//    contenedor del dashboard en el momento en que se guardaron. Un widget
//    pasa a esta unidad automáticamente la primera vez que alguien lo
//    mueve o redimensiona.
//
// Con esto, el layout de los widgets migrados se recalcula solo al cambiar
// el ancho de pantalla (dashboards mas chicos/grandes), sin romper nada de
// lo que ya existía en pixeles.

export const toEffectivePx = (card, containerWidth) => {
  if (card?.layoutUnit === 'pct' && containerWidth) {
    return {
      x: (card.x / 100) * containerWidth,
      y: (card.y / 100) * containerWidth,
      width: (card.width / 100) * containerWidth,
      height: (card.height / 100) * containerWidth,
    };
  }
  return { x: card?.x, y: card?.y, width: card?.width, height: card?.height };
};

export const pxToPercent = (pxValues, containerWidth) => {
  if (!containerWidth) {
    // No debería pasar (el contenedor ya está montado cuando se edita un
    // widget existente), pero por las dudas no dividimos por 0.
    return { ...pxValues, layoutUnit: 'px' };
  }
  return {
    x: (pxValues.x / containerWidth) * 100,
    y: (pxValues.y / containerWidth) * 100,
    width: (pxValues.width / containerWidth) * 100,
    height: (pxValues.height / containerWidth) * 100,
    layoutUnit: 'pct',
  };
};
